import log from '@/services/logger/log';
import {getMarketCodeFromPathname, getServiceWorkerUrl} from '@/utils/serviceWorkerUtils';

const registerServiceWorker = async () => {
    try {
        const marketCode = getMarketCodeFromPathname(window.location.pathname);
        const swScope = marketCode ? `/${marketCode}/` : '/';
        const swReg =
            (await navigator.serviceWorker.getRegistration(swScope)) ||
            (await navigator.serviceWorker.register(getServiceWorkerUrl(window.location.pathname)));

        return swReg;
    } catch (e) {
        log.info('Unable to register service worker.', e);
    }

    return null;
};

const postMessage = async (message) => {
    const swReg = await registerServiceWorker();

    if (!swReg) return;

    try {
        const registration = await navigator.serviceWorker.ready;

        registration.active.postMessage(message);
        log.debug(`postMessage to serviceWorker success, message: ${JSON.stringify(message)}`);
    } catch (e) {
        log.debug(`postMessage to serviceWorker error: ${JSON.stringify(e)}`);
    }
};

const MESSAGE_TYPES = {
    OPENED: 'OPENED',
    SET_FIREBASE_CONFIG: 'SET_FIREBASE_CONFIG',
};

const sendOpenedMessage = async () => {
    await postMessage({type: MESSAGE_TYPES.OPENED});
};

const sendFirebaseConfig = async (firebaseConfig) => {
    await postMessage({
        type: MESSAGE_TYPES.SET_FIREBASE_CONFIG,
        config: firebaseConfig,
    });
};

export default {
    registerServiceWorker,
    postMessage,
    sendFirebaseConfig,
    sendOpenedMessage,
};
